function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import "../config";
import React from 'react';
import { STYLE_WRAPPER_TYPE } from "../utils/constants";
import * as R from 'unitx/ramda';
import { View } from 'react-native';
import useForwardRef from "../hooks/useForwardRef";
import useStateWithCallback from "../hooks/useStateWithCallback";
import { useLayout } from "../hooks/native";
import { withTheme } from "../theme";
export const wrapWithRelativeSizeStyleContainer = Component => /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const {
    style = {}
  } = props,
        rest = _objectWithoutProperties(props, ["style"]);

  return /*#__PURE__*/React.createElement(View, {
    style: style
  }, /*#__PURE__*/React.createElement(Component // @ts-ignore
  , _extends({
    ref: ref,
    style: {
      width: '100%',
      height: '100%'
    }
  }, rest)));
});
export const wrapWithFixedSizeStyleContainer = Component => /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const {
    style = {},
    onLayout: onLayoutProp
  } = props,
        rest = _objectWithoutProperties(props, ["style", "onLayout"]);

  const _useLayout = useLayout(),
        {
    onLayout
  } = _useLayout,
        layout = _objectWithoutProperties(_useLayout, ["onLayout"]);

  const onLayoutCallback = React.useCallback(R.pipe(onLayout, R.when(R.isNotNil, onLayoutProp)), [onLayoutProp, onLayout]);
  return /*#__PURE__*/React.createElement(View, {
    style: style,
    onLayout: onLayoutCallback
  }, /*#__PURE__*/React.createElement(Component // @ts-ignore
  , _extends({
    ref: ref,
    style: {
      width: layout.width,
      height: layout.height
    }
  }, rest)));
});
export const wrapWithUtilizer = Component => /*#__PURE__*/React.forwardRef( // @ts-ignore
(props = {}, forwardRef) => {
  const mutableData = React.useRef({
    props
  });
  const [state, setState] = useStateWithCallback({
    key: 0
  });
  React.useMemo(() => {
    mutableData.current.props = props;
  }, [props]);
  const ref = useForwardRef(forwardRef, null, () => ({
    setNativeProps: (newProps = {}, callback) => {
      mutableData.current.props = _objectSpread(_objectSpread({}, mutableData.current.props), newProps);
      setState({
        key: state.key + 1
      }, callback);
    }
  }));
  return /*#__PURE__*/React.createElement(Component, _objectSpread({
    ref
  }, mutableData.current.props));
});

const wrapComponent = (Component, // @ts-ignore
config = {}) => {
  var _config$isEqual;

  const {
    addSetNativeProps = false,
    isForwardRef = false,
    styleWrapper,
    withTheme: withThemeConfig
  } = config;
  const processedComponent = R.pipe(R.ifElse(R.always(isForwardRef), React.forwardRef, R.identity), R.ifElse(R.always(addSetNativeProps), wrapWithUtilizer, R.identity), R.ifElse(R.always(styleWrapper === STYLE_WRAPPER_TYPE.fixedSize), wrapWithFixedSizeStyleContainer, R.identity), R.ifElse(R.always(styleWrapper === STYLE_WRAPPER_TYPE.relativeSize), wrapWithRelativeSizeStyleContainer, R.identity), R.when(R.always(withThemeConfig), withTheme))(Component);
  const component = /*#__PURE__*/React.memo(processedComponent, (_config$isEqual = config.isEqual) !== null && _config$isEqual !== void 0 ? _config$isEqual : R.equals);
  return component;
};

export default wrapComponent;